import { FETCH_BIKEPOLICYTYPES_FAILURE, FETCH_BIKEPOLICYTYPES_REQUEST, FETCH_BIKEPOLICYTYPES_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const bikePolicyTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BIKEPOLICYTYPES_REQUEST:
            return {
                ...state,
            }
        case FETCH_BIKEPOLICYTYPES_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_BIKEPOLICYTYPES_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}